// Group databases — the third segment of a document's composite id
// (`{number}#{location}#{groupDb}`, e.g. `150961#782#WEBGRP`).
//
// TODO: hardcoded until the backend exposes a groups endpoint. Sourced from the
// US and CA group lists; the shared `C.E.S. (...)` wrapper has been stripped so
// only the distinguishing part of each name remains.
//
// Two codes appear in both the US and CA lists under different names. The code
// is all the composite id carries, so they can't be told apart when filtering —
// both names are kept, US first, separated by ` / `:
//   DELGRP — "Tamlite Resi - Recd Group Office" (US) / "Tamlite Lighting Group" (CA)
//   MCGGRP — "MCG USA" (US) / "MCG Group" (CA)
export const GROUPS: Record<string, string> = {
  ANEGRP: 'Atlanta North East Group Office',
  ASEGRP: 'Austin East Group Office',
  ASHGRP: 'Asheville Group Office',
  ATSGRP: 'Atlanta South Group Office',
  AUGGRP: 'Augusta Group Office',
  AUSGRP: 'Austin West Group Office',
  BIRGRP: 'Birmingham Group Office',
  BLUGRP: 'Bluffton Group Office',
  BNWGRP: 'Boston North West Group Office',
  BOCGRP: 'Boston Central Group Office',
  BONGRP: 'Boston North Group Office',
  BOSGRP: 'Boston South Group Office',
  BROGRP: 'Broward Group Office',
  BSNGRP: 'Boston Group Office',
  CAPGRP: 'Cape and Islands Group Office',
  CDCGRP: 'Data and Communications Group',
  CDOGRP: 'Colorado Mountain Group Office',
  CEFGRP: 'Fusion Lamps',
  CENGRP: 'Centaur Accessories',
  CFFGRP: 'Centaur',
  CHAGRP: 'Charleston Group Office',
  CHAREG: 'Charleston Regional Office',
  CHCGRP: 'Chicago Central Group Office',
  CHEGRP: 'Piedmont Group Office',
  CHLGRP: 'Charlotte Group Office',
  CHNGRP: 'Chicago South Group Office',
  CHSGRP: 'Northern Indiana Group Office',
  CHTGRP: 'Chattanooga Group Office',
  CHWGRP: 'Chicago North Group Office',
  CIDGRP: 'TAMCO Freight Group',
  CINGRP: 'Cincinnati Group Office',
  CLBGRP: 'Columbus Group Office',
  CLDGRP: 'Closed Location Group',
  CLEGRP: 'Cleveland Group Office',
  CLSGRP: 'Charleston South Group Office',
  CMAGRP: 'Miami Central Group Office',
  CNWGRP: 'Chicago North West Group Office',
  COLGRP: 'Columbia Group Office',
  CONGRP: 'Colorado North Group Office',
  CORGRP: 'Corpus Christi Group Office',
  CPDGRP: 'Central Piedmont Group',
  CPJGRP: 'Charleston Projects Group',
  CPVGRP: 'Centaur PVC',
  CSTGRP: 'Centaur Steel',
  CTSGRP: 'OLD - Charlotte South Group Office',
  DADGRP: 'Miami South Group Office',
  DALGRP: 'OLD Dallas Group Office',
  DAYGRP: 'Daytona Beach Group Office',
  DELGRP: 'Tamlite Resi - Recd Group Office / Tamlite Lighting Group',
  DENGRP: 'Colorado South Group Office',
  DLNGRP: 'Dallas Group Office',
  DRAGRP: 'Draper Group Office',
  DSNGRP: 'Dallas North Group Office',
  EXPGRP: 'Export Group Office',
  FTMGRP: 'Fort Myers Group Office',
  FTWGRP: 'Fort Worth Group Office',
  FWSGRP: 'DFW South Group Office',
  GBOGRP: 'Greensboro Group Office',
  GFCGRP: 'Gulf Coast Group Office',
  GSAGRP: 'Government Solutions Group',
  HAYGRP: 'Atlanta North West Group Office',
  HICGRP: 'Hickory Group Office',
  HLXGRP: 'Tamlite Hi-Lux',
  HOCGRP: 'Houston Central Group Office',
  HONGRP: 'Houston North Group Office',
  HOSGRP: 'Houston South Group Office',
  IDEGRP: 'Inland Empire Group Office',
  INDGRP: 'Indianapolis Group Office',
  ITDEMO: 'CES IT Group',
  ITDEPT: 'IT Department',
  ITDGRP: 'IT Dept Group Office',
  JACGRP: 'Jackson Group Office',
  JANGRP: 'Jacksonville East Group Office',
  JASGRP: 'Jacksonville South Group Office',
  JNCGRP: 'Jacksonville Central Group',
  KCWGRP: 'Kansas City West Group Office',
  KCYGRP: 'Kansas City East Group Office',
  KNXGRP: 'Knoxville Group',
  LANGRP: 'Los Angeles Group Office',
  LASGRP: 'Las Vegas Group Office',
  LAWGRP: 'Atlanta Metro Group Office',
  LMTGRP: 'Longmont Group Office',
  LOLGRP: "Land O'Lakes Group Office",
  MACGRP: 'Macon Group Office',
  MCGGRP: 'MCG USA / MCG Group',
  MEMGRP: 'Memphis Group Office',
  MICGRP: 'Michigan Group Office',
  MIEGRP: 'Michigan East Group Office',
  MISGRP: 'Missouri Group Office',
  MMDGRP: 'Media Marketing Division',
  MNEGRP: 'Marine Solutions Group',
  NACGRP: 'Corporate Solutions Group',
  NANGRP: 'Nashville North Group Office',
  NASGRP: 'Nashville East Group Office',
  NAWGRP: 'Nashville West Group Office',
  NEWGRP: 'New Orleans Group Office',
  NJDGRP: 'New Jersey-Delaware Group Office',
  NSDGRP: 'Nashville Downtown Group Office',
  NWGGRP: 'North West Georgia Group Office',
  ODEGRP: 'Orlando East Group Office',
  OKLGRP: 'Oklahoma City South Group Office',
  OKNGRP: 'Oklahoma City North Group Office',
  ORCGRP: 'Orange County Group Office',
  ORLGRP: 'Orlando Group Office',
  OZAGRP: 'Ozarks Group',
  PDEGRP: 'Philadelphia East Group Office',
  PDWGRP: 'Philadelphia West Group Office',
  PENGRP: 'Pensacola Group Office',
  PHEGRP: 'OLD Phoenix East Group Office',
  PHIGRP: 'Philadelphia Group Office',
  PHSGRP: 'Phoenix East Group Office',
  PHWGRP: 'Phoenix West Group Office',
  PMBGRP: 'Palm Beach Group Office',
  PRIGRP: 'Pricing Group',
  PRRGRP: 'Puerto Rico Group Office',
  PSLGRP: 'Treasure Coast Group Office',
  RACGRP: 'Raleigh Central Group Office',
  RAEGRP: 'East Carolina Group Office',
  RAWGRP: 'Raleigh West Group Office',
  RCHGRP: 'Charlotte South Group Office',
  REGGRP: 'Infrastructure Solutions Group Office',
  RICGRP: 'Richmond Group Office',
  RLEGRP: 'Raleigh East Group Office',
  ROAGRP: 'Roanoke Valley Group Office',
  RPPGRP: 'RPP Group',
  SANGRP: 'San Diego Group Office',
  SAVGRP: 'Savannah Group Office',
  SESGRP: 'F4P',
  SGAGRP: 'South Georgia Group Office',
  SMMGRP: 'Smoky Mountain Group Office',
  SNAGRP: 'San Antonio Group Office',
  SNDGRP: 'Sandhills Group',
  SPBGRP: 'South Palm Beach Group Office',
  SPDGRP: 'Southeast Piedmont Group Office',
  SPTGRP: 'Greenville Group Office',
  STLGRP: 'St. Louis Group Office',
  STRGRP: 'Strategic Accounts Group Office',
  SUNGRP: 'Suncoast Group Office',
  TAMGRP: 'Tampa Group Office',
  TCMGRP: 'Disabled - Tamco Manufacturing',
  TCOGRP: 'TAMCO USA',
  TEFGRP: 'Tamlite E&U Group Office',
  TFLGRP: 'TAMCO Manufacturing',
  THDGRP: 'Tamlite Com OutDr Group',
  TLGGRP: 'Tamlite Manufacturing',
  TLIGRP: 'Tamlite Lay-ins Group',
  TMYGRP: 'Tamlite Amenity Group Office',
  TRIGRP: 'Triad Group Office',
  TTSGRP: 'Tamco Third Party Sales Group Office',
  TUCGRP: 'Tucson Group Office',
  TULGRP: 'Tulsa Group Office',
  VALGRP: 'Ocala Group Office',
  VIBGRP: 'Virginia East Group Office',
  VICGRP: 'Virginia Central Group Office',
  VINGRP: 'Virginia North Group Office',
  WASGRP: 'Washington Group Office',
  WEBGRP: 'Web Group Office',
  WICGRP: 'Wichita Group Office',
  WISGRP: 'Wisconsin Group Office',
  WMAGRP: 'Miami North Group Office',
  WMGGRP: 'Wilmington Group Office',
  WPSGRP: 'Wire Paralleling Services',
  WSSGRP: 'Washington South Group Office',

  // CA groups
  ACCGRP: 'Account Group',
  BCDGRP: 'BC Interior Group',
  BURGRP: 'Burlington Group',
  CITGRP: 'IT Group',
  FRNGRP: 'Lower Mainland Group',
  FUSGRP: 'Fusion Lamps Group',
  IMPGRP: 'F4P - Centaur Group',
  LONGRP: 'London Group',
  MONGRP: 'Montreal Group',
  MTDGRP: 'Maritimes Group',
  NAPGRP: 'Nor. Alberta and Prairies Group',
  OTTGRP: 'Ottawa Group',
  TCAGRP: 'TAMCO Canada',
  TORGRP: 'East Toronto Group',
  VANGRP: 'Southern Alberta Group',
  VASGRP: 'Vancouver Island Group',
  WCAGRP: 'Web Group',
  WOOGRP: 'Woodbridge Group',
  WTOGRP: 'West Toronto Group',
};

export interface GroupOption {
  code: string;
  name: string;
}

/** Every group as `{code, name}`, sorted by code. */
export const GROUP_OPTIONS: GroupOption[] = Object.entries(GROUPS)
  .map(([code, name]) => ({code, name}))
  .sort((a, b) => a.code.localeCompare(b.code));

/** Display name for a code; falls back to the code itself when unknown. */
export function getGroupName(code: string): string {
  return GROUPS[code] ?? code;
}

/**
 * Case-insensitive substring search over both code and name. Results are ranked
 * so the group whose code the user is typing surfaces first:
 *   code prefix > name word start > any substring.
 */
export function searchGroups(query: string): GroupOption[] {
  const q = query.trim().toLowerCase();
  if (!q) return GROUP_OPTIONS;

  const scored: Array<{option: GroupOption; rank: number}> = [];
  for (const option of GROUP_OPTIONS) {
    const code = option.code.toLowerCase();
    const name = option.name.toLowerCase();
    let rank: number;
    if (code.startsWith(q)) rank = 0;
    else if (name.startsWith(q)) rank = 1;
    else if (new RegExp(`\\b${escapeRegExp(q)}`).test(name)) rank = 2;
    else if (code.includes(q) || name.includes(q)) rank = 3;
    else continue;
    scored.push({option, rank});
  }

  // Stable within a rank — GROUP_OPTIONS is already code-sorted.
  return scored.sort((a, b) => a.rank - b.rank).map(entry => entry.option);
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
